// verificar codigo en array

export function checkCodeCompo(lista, code) {
  const index = lista.findIndex(element => {
    if (element === code) {
      return true;
    }
  })
  if (index > -1) {
    return true
  } else {
    return false
  }
} 